// ====== TAX CONSTANTS 2025-2026 ======
// Tách từ tax.jsx để tái sử dụng trong toàn bộ phần mềm

// Biểu thuế lũy tiến từng phần — NLĐ
export const TAX_BRACKETS_2026 = [
  { min: 0, max: 10_000_000, rate: 0.05, label: "Bậc 1", deduct: 0 },
  { min: 10_000_000, max: 30_000_000, rate: 0.10, label: "Bậc 2", deduct: 500_000 },
  { min: 30_000_000, max: 50_000_000, rate: 0.20, label: "Bậc 3", deduct: 3_500_000 },
  { min: 50_000_000, max: 100_000_000, rate: 0.30, label: "Bậc 4", deduct: 8_500_000 },
  { min: 100_000_000, max: Infinity, rate: 0.35, label: "Bậc 5", deduct: 13_500_000 },
];

export const TAX_BRACKETS_2025 = [
  { min: 0, max: 5_000_000, rate: 0.05, label: "Bậc 1", deduct: 0 },
  { min: 5_000_000, max: 10_000_000, rate: 0.10, label: "Bậc 2", deduct: 250_000 },
  { min: 10_000_000, max: 18_000_000, rate: 0.15, label: "Bậc 3", deduct: 750_000 },
  { min: 18_000_000, max: 32_000_000, rate: 0.20, label: "Bậc 4", deduct: 1_650_000 },
  { min: 32_000_000, max: 52_000_000, rate: 0.25, label: "Bậc 5", deduct: 3_250_000 },
  { min: 52_000_000, max: 80_000_000, rate: 0.30, label: "Bậc 6", deduct: 5_850_000 },
  { min: 80_000_000, max: Infinity, rate: 0.35, label: "Bậc 7", deduct: 9_850_000 },
];

// Giảm trừ gia cảnh
export const DEDUCTION_2026 = { self: 15_500_000, dependent: 6_200_000 };
export const DEDUCTION_2025 = { self: 11_000_000, dependent: 4_400_000 };

// Tỷ lệ BH bắt buộc NLĐ (BHXH 8% + BHYT 1.5% + BHTN 1%)
export const INSURANCE_RATE = 0.105;

// Ngưỡng miễn thuế HKD
export const BIZ_TAX_EXEMPT = 1_000_000_000;
export const BIZ_TAX_QUARTER_EXEMPT = BIZ_TAX_EXEMPT / 4;

// Ngành nghề kinh doanh — tỷ lệ GTGT & TNCN
export const BIZ_INDUSTRIES = [
  { id: "trade", label: "Phân phối, cung cấp hàng hóa", icon: "🏪", vatRate: 0.01, pitRate: 0.005, examples: "Bán lẻ tạp hóa, điện tử, quần áo..." },
  { id: "service_goods", label: "Dịch vụ gắn với hàng hóa / XD có bao thầu NVL", icon: "🍜", vatRate: 0.03, pitRate: 0.015, examples: "Nhà hàng, quán ăn, sửa xe, xây dựng có vật tư..." },
  { id: "service", label: "Dịch vụ, xây dựng không bao thầu NVL", icon: "🔧", vatRate: 0.05, pitRate: 0.02, examples: "Tư vấn, thiết kế, vận tải..." },
  { id: "manufacturing", label: "Sản xuất, vận tải, dịch vụ khác", icon: "🏭", vatRate: 0.03, pitRate: 0.015, examples: "Sản xuất thực phẩm, may mặc..." },
  { id: "rental", label: "Cho thuê tài sản", icon: "🏠", vatRate: 0.05, pitRate: 0.05, examples: "Cho thuê nhà, kho, mặt bằng..." },
  { id: "agent", label: "Đại lý, môi giới, hoa hồng", icon: "🤝", vatRate: 0.05, pitRate: 0.05, examples: "Đại lý bảo hiểm, môi giới, ủy thác..." },
  { id: "other", label: "Hoạt động kinh doanh khác", icon: "📦", vatRate: 0.02, pitRate: 0.01, examples: "Hoạt động khác" },
];

const pad2 = (n) => String(n).padStart(2, "0");
const formatDateVN = (d) => `${pad2(d.getDate())}/${pad2(d.getMonth() + 1)}/${d.getFullYear()}`;
const quarterLabel = (q) => ({ q1: "quý 1", q2: "quý 2", q3: "quý 3", q4: "quý 4" }[q] || q);

export const DECLARATION_CYCLES = [
  { id: "auto", label: "Tự động theo ngưỡng doanh thu" },
  { id: "quarter", label: "Khai theo quý" },
  { id: "month", label: "Khai theo tháng" },
];

export const PIT_METHODS = [
  { id: "auto", label: "Tự động theo nhóm doanh thu" },
  { id: "revenue_ratio", label: "Theo tỷ lệ trên doanh thu" },
  { id: "taxable_income", label: "Theo thu nhập tính thuế" },
];

const buildQuarterDeadlines = (year) => {
  const qDue = [
    { q: "q1", due: new Date(year, 3, 30) },
    { q: "q2", due: new Date(year, 6, 30) },
    { q: "q3", due: new Date(year, 9, 30) },
    { q: "q4", due: new Date(year + 1, 0, 30) },
  ];
  return qDue.map((x) => ({
    date: formatDateVN(x.due),
    desc: `Hạn nộp hồ sơ khai thuế ${quarterLabel(x.q)}/${year}`,
    type: "khai",
  }));
};

const buildMonthlyDeadlines = (year) => {
  const out = [];
  for (let month = 1; month <= 12; month++) {
    const due = new Date(year, month, 20);
    out.push({
      date: formatDateVN(due),
      desc: `Hạn nộp hồ sơ khai thuế tháng ${pad2(month)}/${year}`,
      type: "khai",
    });
  }
  return out;
};

export const buildTaxDeadlines = (baseYear = new Date().getFullYear()) => {
  const year = Number(baseYear) || new Date().getFullYear();
  return [
    ...buildQuarterDeadlines(year),
    ...buildMonthlyDeadlines(year),
    {
      date: formatDateVN(new Date(year + 1, 2, 31)),
      desc: `Hạn quyết toán thuế năm ${year}`,
      type: "quyettoan",
    },
  ].sort((a, b) => {
    const [da, ma, ya] = a.date.split("/").map(Number);
    const [db, mb, yb] = b.date.split("/").map(Number);
    return new Date(ya, ma - 1, da) - new Date(yb, mb - 1, db);
  });
};

// Backward-compatible export dùng cho các màn hình cũ
export const DEADLINES = buildTaxDeadlines();

// Hướng dẫn từng bước cho mỗi loại thuế
export const GUIDE_STEPS = {
  salary: [
    { title: "Xác định tổng thu nhập", desc: "Tổng hợp lương cơ bản, phụ cấp, thưởng, thu nhập ngoài lương trong tháng/năm." },
    { title: "Trừ các khoản miễn thuế", desc: "Trừ phụ cấp ăn trưa (≤730k), phụ cấp điện thoại, công tác phí, đồng phục... theo quy định." },
    { title: "Trừ bảo hiểm bắt buộc", desc: "BHXH 8% + BHYT 1.5% + BHTN 1% = 10.5% × lương đóng BH (tối đa 46.8tr cho BHXH)." },
    { title: "Trừ giảm trừ gia cảnh", desc: "Bản thân: 15.5tr/tháng. Mỗi người phụ thuộc: 6.2tr/tháng (cần đăng ký MST)." },
    { title: "Tính thu nhập tính thuế", desc: "Thu nhập tính thuế = Thu nhập chịu thuế − Giảm trừ. Nếu ≤ 0 thì không phải nộp thuế." },
    { title: "Áp dụng biểu thuế lũy tiến", desc: "Áp bảng 5 bậc (2026): 5% → 10% → 20% → 30% → 35% theo từng phần thu nhập." },
    { title: "Kê khai và nộp thuế", desc: "Nộp tờ khai tháng/quý trên eTax. Quyết toán năm trước 31/3 năm sau." },
  ],
  business: [
    { title: "Xác định doanh thu", desc: "Tổng doanh thu từ hoạt động kinh doanh trong kỳ tính thuế." },
    { title: "Xác định thuế suất", desc: "Thuế suất TNCN tùy ngành: Phân phối/cung cấp hàng hóa 0.5%, Dịch vụ 2%, Sản xuất/vận tải/xây dựng 1.5%, Hoạt động khác 1%." },
    { title: "Tính thuế TNCN", desc: "Thuế TNCN = Doanh thu × Thuế suất TNCN tương ứng." },
    { title: "Tính thuế GTGT (nếu có)", desc: "Thuế GTGT = Doanh thu × Thuế suất GTGT theo ngành nghề." },
    { title: "Kê khai nộp thuế", desc: "Hộ kinh doanh doanh thu trên 1 tỷ/năm khai thuế. Doanh thu từ 1 tỷ trở xuống được miễn thuế GTGT, TNCN." },
  ],
  investment: [
    { title: "Thu nhập từ chứng khoán", desc: "Thuế suất 0.1% trên giá bán mỗi lần chuyển nhượng (không cần lãi/lỗ)." },
    { title: "Cổ tức bằng tiền", desc: "Thuế suất 5% trên giá trị cổ tức nhận được." },
    { title: "Lãi tiền gửi/tiết kiệm", desc: "Miễn thuế TNCN hoàn toàn." },
    { title: "Thu nhập từ bất động sản", desc: "Thuế TNCN 2% trên giá chuyển nhượng." },
    { title: "Kê khai & nộp thuế", desc: "Chứng khoán: công ty CK khấu trừ tại nguồn. Cổ tức: tổ chức chi trả khấu trừ." },
  ],
  enterprise: [
    { title: "Xác định doanh thu", desc: "Toàn bộ tiền bán hàng, gia công, cung ứng dịch vụ kể cả trợ giá, phụ thu. Doanh thu chưa thu tiền vẫn tính." },
    { title: "Xác định chi phí được trừ", desc: "Chi phí thực tế phát sinh, có hóa đơn chứng từ hợp pháp. Chi trả lương ≥ 5 triệu phải chuyển khoản. Không tính chi phí cá nhân, tiền phạt hành chính." },
    { title: "Tính thu nhập chịu thuế", desc: "TNCT = Doanh thu − Chi phí được trừ + Thu nhập khác. Thu nhập khác gồm: lãi tiền gửi, cho thuê tài sản, thanh lý TSCĐ, chênh lệch tỷ giá..." },
    { title: "Trừ thu nhập miễn thuế", desc: "Gồm: thu nhập từ nông nghiệp/thủy sản (trực tiếp), cổ tức nhận từ DN trong nước, lãi trái phiếu Chính phủ, thu nhập DN khởi nghiệp ĐMST (2 năm đầu)." },
    { title: "Trừ lỗ kết chuyển", desc: "Lỗ từ năm trước được chuyển sang tối đa 5 năm liên tiếp. Kết chuyển toàn bộ và liên tục, không được chọn năm." },
    { title: "Xác định thuế suất", desc: "15% (DT ≤ 3 tỷ), 17% (DT 3-50 tỷ), 20% (DT > 50 tỷ). Ưu đãi 10% cho khu CNC, địa bàn KK. Dầu khí 25-50%." },
    { title: "Tạm nộp thuế TNDN theo quý", desc: "Tạm nộp quý không thấp hơn 80% số thuế phải nộp cả năm. Hạn nộp: ngày 30 tháng đầu quý sau. Nếu nộp thiếu >20%, phạt chậm nộp." },
    { title: "Quyết toán thuế TNDN", desc: "Nộp tờ khai quyết toán năm chậm nhất 31/03 năm sau. Kèm BCTC, phụ lục kết chuyển lỗ, ưu đãi thuế. Nộp trên eTax." },
    { title: "Kê khai thuế GTGT", desc: "PP khấu trừ: khai theo tháng (DT > 50 tỷ) hoặc quý. GTGT nộp = Đầu ra − Đầu vào. PP trực tiếp: tỷ lệ % × DT. Hóa đơn đầu vào phải hợp lệ để được khấu trừ." },
    { title: "Khấu trừ & nộp thuế TNCN cho NLĐ", desc: "DN khấu trừ thuế TNCN hàng tháng cho NLĐ và nộp thay. Nộp tờ khai 05/KK-TNCN. Quyết toán TNCN trước 31/03 năm sau." },
  ],
};

// Labels cho nhóm doanh thu HKD
export const GROUP_LABELS = {
  1: "Nhóm 1: ≤ 1 tỷ — Miễn thuế",
  2: "Nhóm 2: Trên 1 tỷ → 3 tỷ",
  3: "Nhóm 3: 3 tỷ → 50 tỷ",
  4: "Nhóm 4: > 50 tỷ",
};

// Labels cho quý
export const QUARTER_LABELS = { q1: "Quý I", q2: "Quý II", q3: "Quý III", q4: "Quý IV" };
export const MONTHS_BY_QUARTER = { q1: ["01", "02", "03"], q2: ["04", "05", "06"], q3: ["07", "08", "09"], q4: ["10", "11", "12"] };
